import { useContext } from 'react';
import V3WsContext from '../providers/V3WebSocketProvider';

const useV3Ws = () => useContext(V3WsContext);

export default useV3Ws;
